module.exports = __webpack_public_path__ + "static/rmhj-12d023a27071052b3936a53aeddf6e39.png";